import NavBar from "../Componants/NavBar";
import HomeSection from "../Componants/HomeSection";
import SubscriptionSection from "../Componants/SubscriptionSection";
import React, {useEffect,useState} from "react";
import { useNavigate } from 'react-router-dom';
import {Ajax} from "../Service/ajax";
import {GridLoader} from "react-spinners";
import Footer from "../Componants/Footer";
import {security} from "../env/Environment";
import SortableCards from "../Componants/SortableCards";
import PartnerLogos from "../Componants/PartnerLogos";
import PricingPlansComparison from "../Componants/PricingPlansComparison";
import Swal from "sweetalert2";
import EvaluationSection from "../Componants/EvaluationSection";

export default function HomePageView(){
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [appName, setAppName]=useState('');
    const [description, setDescription]=useState('');
    const [subscriptions, setSubscriptions]=useState([]);

    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState("default");

    useEffect(() => {
        const uniqueCategories = [];

        subscriptions.forEach((item) => {
            const category = item.category || "default"; // Remplacer null par "default"
            if (!uniqueCategories.includes(category)) {
                uniqueCategories.push(category); // Ajouter uniquement si absent
            }
        });

        setCategories(uniqueCategories); // Mettre à jour l'état avec les catégories uniques
        console.log(categories);
    }, [subscriptions]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const {data} = await Ajax.getRequest(`/exposed/v1/sub/application/${security.ntk_sub_cmp}/subscription/retrieve`);
                setAppName(data.object.name);
                setDescription(data.object.description);
                if(data.object.subscriptionPlans.length > 0){
                    const transformedPlan = data.object.subscriptionPlans.map(item => {
                        return {
                            id:item.id,
                            title: item.title,
                            infos: item.infos,
                            options: item.values,
                            price: item.price,
                            periodicity: item.periodicity,
                            currency:item.devise,
                            category:item.category ? item.category : 'default',
                        };
                    });
                    setSubscriptions(transformedPlan);
                }
            } catch (error) {
                navigate("/error-page", { state: { errorCode: error.response.status } });
            }finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);
    return(
        <>
            {loading ? (
                <div className="loading-overlay">
                    <div className="loading-spinner">
                        <GridLoader
                            color="#debf66"
                            loading
                            size={15}
                        />
                    </div>
                </div>
            ) : (
                <div className="layout-wrapper layout-content-navbar layout-without-menu">
                    <div className="layout-container">
                        <div className="layout-page">
                            <NavBar/>
                            <div className="content-wrapper">

                                <div className="container-xxl flex-grow-1 container-p-y">
                                    <div className="layout-demo-wrapper">
                                        <HomeSection title={appName} description={description}/>
                                    </div>
                                    <SortableCards/>
                                    <PartnerLogos/>
                                    <SubscriptionSection appName={appName} appDescription={description}
                                                         subscriptions={subscriptions} cmp={security.ntk_sub_cmp} category={category} setCategory={setCategory} categories={categories}/>
                                    <EvaluationSection/>
                                </div>
                                <div className="content-backdrop fade"></div>
                            </div>
                            <Footer/>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
